import { USUARIO_SISTEMA_PERFIL_GET, UsuarioSistemaPerfilActionTypes, UsuarioSistemaPerfilState } from "domain/types/usuarioSistemaPerfil/usuarioSistemaPerfil"

const INITIAL_STATE: UsuarioSistemaPerfilState = {
    usuarioSistemaPerfil: undefined
}

export function UsuarioSistemaPerfilReducer(state = INITIAL_STATE, action: UsuarioSistemaPerfilActionTypes): UsuarioSistemaPerfilState {
    switch (action.type) {
        case USUARIO_SISTEMA_PERFIL_GET:
            return { ...state, usuarioSistemaPerfil: action.payload }
        default:
            return state
    }
}
